import * as TypeGraphQL from "type-graphql";
export var MarketSentimentLevel;
(function (MarketSentimentLevel) {
    MarketSentimentLevel["VERY_BEARISH"] = "VERY_BEARISH";
    MarketSentimentLevel["SOMEWHAT_BEARISH"] = "SOMEWHAT_BEARISH";
    MarketSentimentLevel["BEARISH"] = "BEARISH";
    MarketSentimentLevel["NEUTRAL"] = "NEUTRAL";
    MarketSentimentLevel["SOMEWHAT_BULLISH"] = "SOMEWHAT_BULLISH";
    MarketSentimentLevel["BULLISH"] = "BULLISH";
    MarketSentimentLevel["VERY_BULLISH"] = "VERY_BULLISH";
})(MarketSentimentLevel || (MarketSentimentLevel = {}));
TypeGraphQL.registerEnumType(MarketSentimentLevel, {
    name: "MarketSentimentLevel",
    description: undefined,
});
//# sourceMappingURL=MarketSentimentLevel.js.map